<template>
    <div>
        <!-- SELECT -->
        <b-form-group v-if="question.type === 'select'" :label="label">
            <b-form-select v-model="answer" :options="options" :required="required" :disabled="disabled">
                <template slot="first">
                    <option :value="null" disabled>-- Choisir une réponse --</option>
                </template>
            </b-form-select>
        </b-form-group>
        <!-- RADIO -->
        <b-form-group v-else-if="question.type === 'radio'" :label="label">
            <b-form-radio-group v-model="answer" :options="options" :required="required" :disabled="disabled" stacked/>
        </b-form-group>
        <!-- RANGE -->
        <template v-else-if="question.type === 'range'">
            <label>{{label}}
                <output class="border-primary">{{ answer }}</output>
            </label>
            <div v-if="!disabled" class="d-flex flex-column justify-content-center align-items-center">
                <div class="d-flex justify-content-between align-items-center bg-secondary p-2 w-100">
                    <output class="border-light">{{ min }}</output>
                    <touch-range
                            v-model="answer"
                            class="range w-100 mx-2"
                            :min="min"
                            :max="max"
                            :step="step"
                            :required="required"
                    />
                    <output class="border-light">{{ max }}</output>
                </div>
            </div>
        </template>
        <!-- TEXTAREA -->
        <template v-else-if="question.type === 'textarea'">
            <label>{{label}}</label>
            <b-form-textarea v-model="answer" :required="required" :disabled="disabled" rows="5"/>
        </template>
        <!-- SWITCH -->
        <template v-else-if="question.type === 'switch'">
            <label>{{label}}<b v-if="disabled"> {{answer}}</b> </label>
            <div v-if="!disabled" class="d-flex justify-content-start align-items-center">
                <span>{{question.answers[1]}}</span>
                <switch-extended :value="null" @input="answer = $event" class="mx-2"/>
                <span>{{question.answers[0]}}</span>
            </div>
        </template>
        <!-- CHECKBOX -->
        <b-form-group :label="label" v-else-if="question.type === 'checkbox'">
            <b-form-checkbox-group v-model="answer" :options="options" :disabled="disabled" stacked>
            </b-form-checkbox-group>
        </b-form-group>
        <!-- STARS -->
        <template v-else-if="question.type === 'stars'">
            <label>{{label}}</label>
            <div class="d-flex mb-2" style="max-width: 300px">
                <i v-for="i in max" :key="i" class="fas fa-star fa-2x mx-2"
                   :class="i <= answer ? 'star-picked' : 'star-unpicked'" @click="!disabled ? answer = i : null"
                />
            </div>
        </template>
        <!-- TYPE D'INPUT NON SUPPORTE -->
        <template v-else>
            <p>Le type <b>{{question.type}}</b> n'est pas supporté pour la question <b>{{question.question}}</b></p>
        </template>
    </div>
</template>
<script>
    import TouchRange from "../TouchRange";
    import SwitchExtended from "../SwitchExtended";

    export default {
        name: 'evaluation-question',
        components: {SwitchExtended, TouchRange},
        props: {
            question: Object,
            questionQuestionnaire: Object,
            answers: Array,
            mode: String
        },
        data: () => ({
            answer: null,
            disabled: false
        }),
        mounted() {
            this.disabled = this.mode === 'view'
            // if (this.mode === 'edit') {
            //     this.answer = this.question.type === 'stars' ? Math.round(this.max / 2) :
            //         (this.question.type === 'range' ? Math.round(this.max / 2) : null)
            // } else {
            //     const answer = this.answers.filter((a) => {
            //         return a.question === this.questionQuestionnaire.id
            //     })[0]
            //     if (answer === undefined) this.answer = 'Pas de réponse'
            //     else {
            //         if (this.question.type === 'checkbox') {
            //             if (typeof answer.answer === 'string') this.answer = answer.answer.split(',')
            //             else if (typeof answer.answer === 'object') this.answer = answer.answer
            //         } else
            //             this.answer = answer.answer
            //     }
            // }
            const answer = this.answers.filter((a) => {
                return a.question === this.questionQuestionnaire.id
            })[0]
            if (answer === undefined && this.mode === 'view') this.answer = 'Pas de réponse'
            else {
                if (answer === undefined) {
                    this.answer = this.question.type === 'stars' ? Math.round(this.max / 2) :
                        (this.question.type === 'range' ? Math.round(this.max / 2) : null)
                } else {
                    if (this.question.type === 'checkbox') {
                        if (typeof answer.answer === 'string') this.answer = answer.answer.split(',')
                        else if (typeof answer.answer === 'object') this.answer = answer.answer
                    } else
                        this.answer = answer.answer
                }
            }
        },
        computed: {
            required() {
                return this.questionQuestionnaire.isMandatory
            },
            label() {
                let label = this.question.question;
                if (!this.required) label += ' (optionnel)'
                return label
            },
            step() {
                return parseInt(this.max / this.question.answers.length)
            },
            min() {
                return parseInt(this.question.answers[0])
            },
            max() {
                return parseInt(this.question.answers[this.question.answers.length - 1])
            },
            options() {
                return this.question.answers.map((r) => {
                    return {value: r, text: r}
                })
            }
        },
        watch: {
            async answer() {
                if (this.mode === 'edit') {
                    let answer = this.answer
                    if (this.question.type === 'switch') {
                        if (answer !== null) {
                            answer = answer ? this.question.answers[0] : this.question.answers[1]
                        }
                    }
                    this.$emit('change', {
                        question: this.questionQuestionnaire.id,
                        answer: answer,
                        obligatoire: this.questionQuestionnaire.isMandatory
                    })
                }
            }
        }
    }
</script>
